import React from 'react';

const AlgorithmDescription = () => {
  return (
    <div className="description-card shadow-lg p-3">
      <h3 className="section-title">Algorithm Description</h3>
      <div id="algorithmDescription">
        This program implements the <b>Quick Sort</b> algorithm, a popular and efficient 
        <b>divide-and-conquer</b> sorting method. It divides the array into smaller partitions based on a 
        <b>pivot</b> element and recursively sorts each partition.
      </div>
      <div id="timeComplexity">
        <div>
          <b>Time Complxity:</b>&nbsp;&nbsp;
          <span style={{fontSize: '20px'}}>O</span>
          <span style={{fontSize: '18px'}}>(</span>
          <span style={{fontSize: '15px'}}>n log n</span>
          <span style={{fontSize: '18px'}}>)</span>
        </div>
      </div>
      <h3 className="section-title mt-4">Real-Life Use Cases</h3>
      <div id="realLifeUse">
        <ul>
            <li><b>Database Management:</b> Sorting large datasets for efficient querying and indexing.</li>
            <li><b>E-commerce Platforms:</b> Sorting products by price, rating, or relevance.</li>
            <li><b>Scheduling Systems:</b> Arranging tasks or events based on priority or time.</li>
        </ul>
      </div>
    </div>
  );
};

export default AlgorithmDescription;
